import React from "react";
import { inject, observer } from "mobx-react";
import Agent from "../../api/agent";
import ReCAPTCHA from "react-google-recaptcha";
import { validateIfInputIsEmail } from '../../helpers/validationChecks'

const SubscribeRecaptchaRef = React.createRef();
const captchaSiteKey = '6LcCF7QUAAAAAORc8GBjqpr0XmTzoDS4E9l1DY89';

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class SubscribeMasterpiece extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscribeName: localStorage.getItem("full_name"),
            subscribeEmail: localStorage.getItem("primary_email") || localStorage.getItem("fb_email") || localStorage.getItem("goog_email") || localStorage.getItem("login_email"),
        }
    }

    subscribeSubmitHandle = () => {

        if (!this.state.subscribeName) {
            this.props.navigatorStore.openErrorModal("Entering name is mandatory.");
            return;
        }
        if (!this.state.subscribeEmail) {
            this.props.navigatorStore.openErrorModal("Entering email is mandatory.")
            return;
        }
        if (!!this.state.subscribeEmail && !validateIfInputIsEmail(this.state.subscribeEmail)) {
            this.props.navigatorStore.openErrorModal("Please enter a valid email.")
            return;
        }

      

        // if (!this.state.captchaDone) {
        //     this.props.navigatorStore.openErrorModal("Please complete the captcha before sending a request.")
        //     return;
        // }
        this.executeRecaptcha();
        

    };

    subscribeAPI = () => {
        var formData = new FormData();
        formData.append("name", this.state.subscribeName);
        formData.append("email", this.state.subscribeEmail);

        Agent.generalData.subscribeRequest(formData).then((res) => {
            console.log(res);
            if (res.error == 'False') {
                this.props.navigatorStore.openErrorModal("Successfully Subscribed ", false, false, true)
                this.setState({
                    subscribeEmail : "",
                    subscribeName : "",
                })
                // this.executeRecaptcha();

            } else {
                this.props.navigatorStore.openErrorModal("Something went wrong! Please try again later");
            }
        })
    }

    handleInputChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        })
    };

    ValidateEmail = mail => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return true;
        }
        return false;
    };


    handleRecaptchaChange = value => {
        if (value === null) {
            this.googleCaptchaError();
        }
        // this.setState({
        //     captchaDone: true
        // });
        this.subscribeAPI();
        ReCAPTCHA.reset();
    };

    executeRecaptcha = () => {
        if (SubscribeRecaptchaRef) {
            SubscribeRecaptchaRef.current.reset();
        }
        SubscribeRecaptchaRef.current.execute();
        this.setState({
            captchaDone : false
        })
    };


    googleCaptchaError = () => {
        this.props.navigatorStore.openErrorModal("Google Captcha Failed", false, false, true)
        return false;
    };

    render() {
        return (
            <div className="bg-grey pb-25">
                <div className="rectangle-featured-artworks bg-grey pb-25">
                    <div style={{ display: "flex" }}>
                        <div className="col-md-12 pl-0 pr-0">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="title-featured-artworks mt-15"
                                        style={{ margin: "unset", flex: "1" }}>
                                        ADD EMOTIONS TO YOUR INBOX
                                        <hr className="line-category-name "></hr>

                                        <p className="heading-desc-text">
                                      {/*       Subscribe to the weekly newsletter to get the best <br
                                                className="hidden-xss" /> masterpieces
                                        right
                                        in
                                        your inbox. */}
                                        Subscribe to our newsletters to get news and updates right in your inbox.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-25 mb-25">
                                <div className="col-md-4 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">YOUR NAME</label>
                                        <input type="text"
                                            className="form-control bg-white" name="subscribeName"
                                            onChange={this.handleInputChange}
                                            value={this.state.subscribeName} placeholder="John Doe" />
                                    </div>
                                </div>
                                <div className="col-md-5 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">YOUR EMAIL</label>
                                        <input className="form-control bg-white"
                                            type="email"
                                            onChange={this.handleInputChange}
                                            value={this.state.subscribeEmail}
                                            name="subscribeEmail"
                                            placeholder="exmail@example.com" />
                                    </div>
                                </div>
                                {/* ref={SubscribeRecaptchaRef} */}

                                {/* <div style={{marginTop : "15px"}} className="col-md-4 mb-15">
                                    <div className="form-group"> */}

                                        <ReCAPTCHA
                                            ref={SubscribeRecaptchaRef}
                                            size="invisible"
                                            sitekey={captchaSiteKey}
                                            onChange={this.handleRecaptchaChange}
                                            onErrored={this.googleCaptchaError}
                                        />
                                    {/* </div> */}
                                {/* </div> */}
                                <div className="col-md-3 mb-15">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp; &nbsp;</label>
                                        <br />
                                        <button onClick={this.subscribeSubmitHandle}
                                            className="masterpieces-primary-buttons button request-btn">
                                            SUBSCRIBE
                                        </button>
                                    </div>
                                </div>
                            </div>


                            {/*<div className="col-md-6 subscribe-block">
                                    <div className="input-group subscribe-input-block">
                                        <input type="email" className="form-control black-border" name="subscribeEmail"
                                               placeholder="Recipient's username"
                                               aria-label="Recipient's username"
                                               onChange={this.handleInputChange}
                                               aria-describedby="basic-addon2"/>
                                        <div className="input-group-append">
                                            <button onClick={this.subscribeSubmitHandle}
                                                    className="masterpieces-primary-buttons button request-btn subscribe-btn">
                                                SUBSCRIBE
                                            </button>
                                        </div>
                                    </div>
                                </div>*/}

                        </div>
                    </div>
                </div>
            </div>

        )
    }
}




// WEBPACK FOOTER //
// ./src/components/sectionHolders/subscribe-section.js